export default __webpack_public_path__ + "static/media/CircleRed.8ee3de3d.svg";